import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../store/actions';
import * as constants from '../common/constants';
import { Container } from 'reactstrap';
import BevTable from '../components/Table';


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setTitle: (title) => dispatch(actions.base.setTitle(title)),
  }
}


const mapStateToProps = (state) => {
  return {
    config: state.auth.config,
  }
}

class Abonnenten extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      members: false,
      offset: 0,
      pagination: 50,
      wer: '',
      aktive: true,
    }
  }

  componentDidMount() {
    this.props.setTitle("Abonnenten")
  }

  addMember = () => {
    this.props.history.push('/abonnent/new')
  }

  columns =  [
      {name: "kundennummer", align: "left"},
      {name: "name", align: "left"},
      {name: "prozent", align: "left"},
      {name: "heftsum", align: "left"},
  ];



  render() {
    return <Container>
              <BevTable titel="Abonnenten" 
                url={constants.BASE_URL + "abonnent/"} 
                detailUrl='/abonnent/' 
                location={this.props.location}
                newText='neuen Abonnenten anlegen'
                new={this.addMember}
                searchFieldName='namefilter' 
                config={this.props.config}
                switchButton={true}
                switchText={'nur aktive Abonnenten'}
                switchUrl='aktiv=True'
                columns={this.columns} />
            </Container>
  }

}



Abonnenten.defaultProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Abonnenten);
